<i18n src="./../../i18n/main_map_item.json"></i18n>

<template>
    <div class="col-lg-6 col-12">
        <div class="row pt-3">
            <div class="col-3 p-0 pt-1 text-right"><img class="lazy mt-location" data-src="/assets/mt-location.png" alt="location"></div>
            <div class="col-9">
                <h6 class="font-weight-bold mb-0">{{ itemData.city }}</h6>
                <p class="small mb-0" v-if="itemData.addressNextLine" v-text="itemData.addressNextLine + ', ' + itemData.address"/>
                <p class="small mb-0" v-else v-text="itemData.address"/>
                <router-link v-if="(Const.PRIMARY_LOCALE === 'pl' || Const.PRIMARY_LOCALE === 'de') && itemData.url" :to="{name: 'departmentPage', params: {department: cleanPath(itemData.url)}}" v-text="$t('departmentSite')"/>
                <router-link v-else :to="{name: 'departments'}" style="visibility: hidden;" v-text="$t('departmentSite')"/>
                <div class="d-none">{{ itemData.xcoordinate }},{{ itemData.ycoordinate }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainMapItem",
        props: {
            itemData: {}
        },
        data () {
            return {
                locale: this.$i18n.locale,
            }
        },
        methods: {
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            }
        }
    }
</script>

<style scoped>
</style>